import { CreativeInfoItem } from '@blisspointmedia/bpm-types/dist/Creative';
import { BsPlayBtn } from 'react-icons/bs';
import { EmptyState } from '@Components/EmptyState';
import { toPrettySpend } from '@src/utils/performance-utils';
import { CreativeMediaPlayer } from './CreativeMediaPlayer';

interface CreativeViewProps {
  cid: string;
  selectedCreative: CreativeInfoItem | undefined;
}

export const CreativeView = ({ cid, selectedCreative }: CreativeViewProps) => {
  if (!cid || !selectedCreative) {
    return (
      <div className='creatives-view' data-testid='creative-view'>
        <EmptyState
          className='creatives-view-placeholder'
          icon={<BsPlayBtn size={100} />}
          description='Select a video thumbnail below to watch a video and see video info.'
        />
      </div>
    );
  }

  return (
    <div className='creatives-view' data-testid='creative-view'>
      <div className='creative-media'>
        <CreativeMediaPlayer
          cid={cid}
          selectedCreative={selectedCreative}
          key={selectedCreative.file}
        />
      </div>
      <div className='creative-description'>
        <div>
          <b>Title: </b>
          {selectedCreative.name || 'No title available'}
        </div>
        <div>
          <b>Length: </b>
          {selectedCreative.length || 'No length available'}
        </div>
        <div>
          <b>ISCI(s): </b>
          {selectedCreative.isciList.join(', ')}
        </div>
        <div>
          <b>Start-End Date(s): </b>
          {selectedCreative.mostRecentDateRanges.join(', ') || 'No date(s) available'}
        </div>
        <div>
          <b>Spend: </b>
          {toPrettySpend(Math.round(selectedCreative.spend))}
        </div>
        <div>
          <b>Spots: </b>
          {selectedCreative.numSpots.toLocaleString('en-US')}
        </div>
      </div>
    </div>
  );
};
